export const convertOpeningTime = time => {
  if (time) {
    if (time[0] == 0) {
      return time.substring(1).replace(':', '.')
    }
    return time.replace(':', '.')
  } else return time
}
